export default __webpack_public_path__ + "static/media/1965.10ce703e.png";